import { createAction } from 'redux-actions'
import {
  EDITING_STARTED,
  EDITING_ENDED,
  NOTIFY_SERVER_EDITING_ENDED,
  EDIT_COMMITTED,
  USER_DISCONNECTED,
} from '@/state/types/editing'

// Right now this actions are handling / mutating newsletters reducers only
export const editingStarted = createAction(EDITING_STARTED, undefined, () => ({
  resource: 'newsletters',
  update: true,
}))

export const editingEnded = createAction(EDITING_ENDED, undefined, () => ({
  resource: 'newsletters',
  update: true,
}))

export const notifyServerEditingEnded = createAction(NOTIFY_SERVER_EDITING_ENDED)

export const editCommitted = createAction(EDIT_COMMITTED, undefined, () => ({
  resource: 'newsletters',
  update: true,
}))

// Helper for unlocking editing when user disconnets
export const userDisconnected = createAction(USER_DISCONNECTED, undefined, () => ({
  resource: 'newsletters',
  update: true,
}))



// WEBPACK FOOTER //
// ./state/actions/editing.js